import Modal from "bootstrap/js/dist/modal";
import jumpTo from "jump.js";

document.querySelectorAll(".modal").forEach(modal => {
  modal.addEventListener('hidden.bs.modal', () => {
    modal.querySelectorAll('video').forEach(vid => vid.pause());
  });
});

document.querySelectorAll(".btn-modal-close").forEach(btn => {
  const parentModalElement = btn.closest(".modal");

  if (parentModalElement) {
    const parentModal = new Modal(parentModalElement);

    btn.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      parentModal.hide();

      const href = btn.getAttribute("href");
      if (href.startsWith("#")) {
        setTimeout(() => {
          const navbarHeight = document.querySelector('nav.navbar').clientHeight;
          const element = document.getElementById(href.substring(1));

          jumpTo(element, {
            duration: 500,
            offset: -(navbarHeight + 20),
          })
        }, 500);
      }
    });
  }
});
